// extracted by mini-css-extract-plugin
export default {"crossButton":"CrossButton_crossButton__F8MCP","crossImage":"CrossButton_crossImage__v1awf"};